export interface IODataEnumValue {
    name: string;
    value: number;
}

export interface IODataEnumDescriptor {
    name: string;
    values: IODataEnumValue[];
}

export interface IODataPropertyDescriptor {
    name: string;
    edmType: string;
    isNullable: boolean;
    isKey: boolean;
    isReadOnly: boolean;
    enumTypeName: string | null;
    isFilterable?: boolean;
    isSortable?: boolean;
}

export interface IODataEntityDescriptor {
    name: string;
    entitySetName: string;
    keyProperties: string[];
    properties: IODataPropertyDescriptor[];
}

export interface IODataMetadataCatalog {
    fetchedAt: string;
    version: string;
    entities: Record<string, IODataEntityDescriptor>;
    enums: Record<string, IODataEnumDescriptor>;
}

export type ODataOperator =
    | "eq" | "ne" | "gt" | "ge" | "lt" | "le"
    | "contains" | "startswith" | "endswith"
    | "is null" | "is not null";

export interface IODataFilterRow {
    id: string;
    property: string;
    operator: ODataOperator;
    value: string;
}

export interface IODataFormState {
    entity: string;
    select: string[];
    filters: IODataFilterRow[];
    orderByProperty: string;
    orderByDescending: boolean;
    top: number;
    skip: number;
    companies: string[];
    runId: number;
}

export interface IODataQueryResponse {
    value: unknown[];
    totalCount: number | null;
    hasMore: boolean;
    clamped: boolean;
}

export const COMMON_ENTITIES: ReadonlyArray<string> = [
    "CustomerV3",
    "ReleasedProductV2",
    "SalesOrderHeaderV2",
    "SalesOrderLine",
    "BOMVersion",
    "RouteVersion",
];

export const COMPANY_DATA_AREA_IDS: ReadonlyArray<string> = [
    "NSAU", "NSBE", "NSCA", "NSDE", "NSDK", "NSES", "NSFR",
    "NSG1", "NSGB", "NSHK", "NSHR", "NSIT", "NSNL", "NSNZ",
    "NSSA", "NSSE", "NSSL",
];
